<template>
  <div class="box-padding">
    <div :class="{ 'titre-soft-outline': !solobox }">
      {{ titre }}
    </div>
    <div :class="{ 'soft-outline': !solobox }">
      <div style="text-align: left">
        <li class="rapport-items" v-for="lien of liens" :key="lien.titre">
          <a @click="redirectionLegacy(lien.lien)">{{ lien.titre }}</a>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoiteLiens",
  props: {
    solobox: Boolean,
    titre: String,
    liens: Array,
  },
  data() {
    return {};
  },
  methods: {
    redirectionLegacy(lien) {
      window.location.href = lien;
    },
  },
}
</script>